// 每日瓜料 · 单页聚合站数据
// 内容为娱乐资讯主题的虚构演示素材，人物与事件均为化名

export interface RankItem {
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: "up" | "down" | "flat" | "new";
  summary: string;
}

export interface CardItem {
  id: number;
  title: string;
  category: string;
  heat: number;
  date: string;
  excerpt: string;
  img: string;
  tag: string;
}

export interface FreshItem {
  id: number;
  time: string;
  category: string;
  title: string;
  brief: string;
}

export interface ColumnItem {
  id: number;
  title: string;
  deck: string;
  img: string;
  author: string;
  length: string;
  tag: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const site = {
  name: "每日瓜料",
  slogan: "热门瓜 · 一页看全",
  desc: "每日瓜料是一档专为吃瓜群众打造的娱乐热点聚合站，把一周热门瓜料与近期新瓜集中到一页，按热度排列，打开即享完整瓜田总览。",
};

export const hotRank: RankItem[] = [
  { rank: 1, title: "《环岛夜行》剧组杀青，双男主隔空喊话引热议", category: "影视", heat: 98.6, trend: "up", summary: "杀青宴路透曝光后，两位主演的互动动态被网友反复研读，话题阅读量持续攀升。" },
  { rank: 2, title: "新一季《城市漫游计划》官宣常驻阵容", category: "综艺", heat: 95.2, trend: "new", summary: "官微一口气放出六位常驻名单，海报排位引发粉丝新一轮“站位”讨论。" },
  { rank: 3, title: "当红小花机场造型被拍到拎包撒腿就跑", category: "生活", heat: 91.8, trend: "up", summary: "一段模糊的路透视频刷屏，网友一边笑一边扒出同款穿搭，话题热度居高不下。" },
  { rank: 4, title: "悬疑剧《回声之外》开播一周评分冲上8.4", category: "影视", heat: 88.3, trend: "up", summary: "紧凑的叙事节奏被广泛称赞，剧情细节也成了观众逐帧分析的“考古”现场。" },
  { rank: 5, title: "国民舞台剧《长夏未央》全国巡演首站定档", category: "演出", heat: 84.7, trend: "flat", summary: "首轮三城开票即售罄，二手平台求票帖成片出现，主办方宣布加场。" },
  { rank: 6, title: "顶流男团演唱会秒空，黄牛票价被网友吐槽离谱", category: "音乐", heat: 81.5, trend: "up", summary: "抢票难成为社交平台热门议题，粉丝晒出“手速战绩”与“陪跑日常”两派互晒。" },
  { rank: 7, title: "老牌主持人转型直播综艺，首期嘉宾阵容意外", category: "综艺", heat: 77.9, trend: "down", summary: "跨界组合出乎意料却意外有化学反应，首期播放量与讨论度双双走高。" },
  { rank: 8, title: "童年IP动画电影版定档，情怀牌能否奏效", category: "影视", heat: 74.2, trend: "new", summary: "预告片释出后，一代人的“爷青回”记忆被唤起，配音阵容成最大悬念。" },
];

export const weeklyPicks: CardItem[] = [
  {
    id: 1,
    title: "《回声之外》细节复盘：这版结局其实早就埋了伏笔",
    category: "影视",
    heat: 98.6,
    date: "09-09",
    excerpt: "大结局播出后，观众把前十二集的台词、镜头和道具逐一比对，发现所有关键信息其实早有暗示。",
    img: "https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20noir%20set%20with%20scattered%20film%20reels%20and%20old%20typewriter%2C%20warm%20coral%20and%20deep%20green%20tonal%20editorial%20collage%2C%20soft%20dramatic%20lighting%2C%20mystery%20thriller%20poster%20style&width=900&height=600&seq=weekly-echo-outside&orientation=landscape",
    tag: "深度解析",
  },
  {
    id: 2,
    title: "《城市漫游计划》阵容官宣，谁是你的本期必追？",
    category: "综艺",
    heat: 95.2,
    date: "09-08",
    excerpt: "新一季常驻名单尘埃落定，六位成员将解锁三座南方城市，预告里的隐藏嘉宾线索成谜。",
    img: "https://readdy.ai/api/search-image?query=colorful%20flat%20editorial%20illustration%20of%20city%20skyline%20with%20paper%20plane%2C%20travel%20and%20adventure%20theme%2C%20fresh%20green%20and%20warm%20coral%20palette%2C%20clean%20modern%20magazine%20style&width=900&height=600&seq=weekly-city-walk&orientation=landscape",
    tag: "官宣情报",
  },
  {
    id: 3,
    title: "机场奔跑照刷屏背后，路透文化为何屡禁不止",
    category: "生活",
    heat: 91.8,
    date: "09-07",
    excerpt: "一张路人视角的抓拍引发大讨论，从“好笑”到“心疼”，我们聊聊镜头背后的边界问题。",
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20style%20collage%20of%20airport%20gate%20silhouette%20with%20motion%20blur%20and%20runway%20lights%2C%20warm%20sunset%20coral%20tones%2C%20thoughtful%20news%20report%20aesthetic&width=900&height=600&seq=weekly-airport&orientation=landscape",
    tag: "热点观察",
  },
  {
    id: 4,
    title: "《长夏未央》加场官宣，话剧热为何重回大众视野",
    category: "演出",
    heat: 84.7,
    date: "09-06",
    excerpt: "从剧院门口排起的长队看起，探讨一部口碑舞台剧带动的观演热潮与城市文化消费变化。",
    img: "https://readdy.ai/api/search-image?query=elegant%20theater%20stage%20with%20red%20curtain%20and%20spotlight%20beams%2C%20editorial%20still%20life%20collage%2C%20warm%20golden%20and%20coral%20palette%2C%20refined%20performing%20arts%20magazine%20style&width=900&height=600&seq=weekly-stage-play&orientation=landscape",
    tag: "文化观察",
  },
  {
    id: 5,
    title: "票价、抢票与黄牛：一场演唱会背后的众生相",
    category: "音乐",
    heat: 81.5,
    date: "09-05",
    excerpt: "秒空、加场、二开与求票帖轮番上演，我们把一场演唱会的前前后后完整复盘了一遍。",
    img: "https://readdy.ai/api/search-image?query=vibrant%20concert%20stage%20with%20confetti%20and%20crowd%20hands%20silhouettes%2C%20editorial%20collage%2C%20fresh%20green%20and%20coral%20accent%20lighting%2C%20energetic%20music%20magazine%20style&width=900&height=600&seq=weekly-concert&orientation=landscape",
    tag: "行业深挖",
  },
  {
    id: 6,
    title: "童年动画真人电影版，情怀之下我们还能期待什么",
    category: "影视",
    heat: 74.2,
    date: "09-04",
    excerpt: "当熟悉的角色以新形态归来，观众想要的不只是情怀，更是一份诚意满满的答卷。",
    img: "https://readdy.ai/api/search-image?query=nostalgic%20childhood%20cartoon%20toys%20and%20storybook%20collage%20with%20bubbles%2C%20warm%20coral%20and%20cream%20palette%2C%20playful%20editorial%20illustration%20style&width=900&height=600&seq=weekly-childhood&orientation=landscape",
    tag: "前瞻盘点",
  },
];

export interface FilterGroup {
  name: string;
  items: CardItem[];
}

export const filterGroups: FilterGroup[] = [
  {
    name: "影视",
    items: [
      { id: 1, title: "《回声之外》结局复盘：伏笔其实早在第一集", category: "影视", heat: 98.6, date: "09-09", excerpt: "观众逐帧考古，发现开放式结局的关键答案被藏在一个不起眼的道具里。", img: "https://readdy.ai/api/search-image?query=moody%20cinematic%20film%20reel%20and%20clapperboard%20collage%2C%20deep%20green%20and%20coral%20tones%2C%20mystery%20drama%20poster%20aesthetic&width=900&height=600&seq=filter-1&orientation=landscape", tag: "深度解析" },
      { id: 2, title: "童年动画电影版定档，配音阵容成最大悬念", category: "影视", heat: 91.2, date: "09-07", excerpt: "预告片释出，“爷青回”讨论刷屏，主创称会在保留原作精神的同时讲出新意。", img: "https://readdy.ai/api/search-image?query=playful%20cartoon%20characters%20toys%20collage%20on%20warm%20coral%20backdrop%2C%20nostalgia%20theme%2C%20editorial%20magazine%20illustration&width=900&height=600&seq=filter-2&orientation=landscape", tag: "前瞻盘点" },
      { id: 3, title: "暑期档票房榜出炉，口碑片逆袭成为最大赢家", category: "影视", heat: 86.4, date: "09-05", excerpt: "这个档期没有大爆款，却靠扎实口碑杀出多部黑马，市场数据透露哪些信号？", img: "https://readdy.ai/api/search-image?query=cinema%20ticket%20stubs%20and%20popcorn%20collage%20flat%20lay%2C%20warm%20coral%20and%20golden%20tones%2C%20box%20office%20news%20editorial%20style&width=900&height=600&seq=filter-3&orientation=landscape", tag: "市场数据" },
    ],
  },
  {
    name: "综艺",
    items: [
      { id: 1, title: "《城市漫游计划》官宣常驻，隐藏嘉宾成谜", category: "综艺", heat: 95.2, date: "09-08", excerpt: "海报排位与站次顺序引发站位讨论，官方预告里留下三处待解线索。", img: "https://readdy.ai/api/search-image?query=colorful%20city%20travel%20map%20with%20route%20markers%20and%20paper%20plane%20collage%2C%20fresh%20green%20coral%20palette%2C%20variety%20show%20editorial%20style&width=900&height=600&seq=filter-z1&orientation=landscape", tag: "官宣情报" },
      { id: 2, title: "老牌主持人转型直播综艺，首期意外有戏", category: "综艺", heat: 88.1, date: "09-06", excerpt: "跨界组合被低估，首期播放量破纪录，观众喊话希望常驻。", img: "https://readdy.ai/api/search-image?query=live%20broadcast%20studio%20with%20microphones%20and%20screens%20collage%2C%20warm%20coral%20and%20teal%20accent%20lights%2C%20modern%20tv%20show%20editorial%20style&width=900&height=600&seq=filter-z2&orientation=landscape", tag: "热点观察" },
      { id: 3, title: "慢综艺扎堆回归，治愈系还能再火多久", category: "综艺", heat: 80.3, date: "09-03", excerpt: "多档生活流综艺同期上线，观众审美疲劳之下，差异化才是破局关键。", img: "https://readdy.ai/api/search-image?query=cozy%20cottage%20living%20room%20with%20teacup%20and%20plants%20collage%2C%20fresh%20green%20and%20cream%20tones%2C%20healing%20lifestyle%20editorial%20style&width=900&height=600&seq=filter-z3&orientation=landscape", tag: "行业观察" },
    ],
  },
  {
    name: "音乐",
    items: [
      { id: 1, title: "顶流男团巡演秒空，票价生态遭网友吐槽", category: "音乐", heat: 89.7, date: "09-05", excerpt: "手速帖与陪跑帖刷屏，我们梳理了一场演唱会背后的售票与转售生态。", img: "https://readdy.ai/api/search-image?query=concert%20light%20beams%20and%20music%20notes%20collage%2C%20vibrant%20green%20coral%20glow%2C%20idol%20concert%20editorial%20poster%20style&width=900&height=600&seq=filter-m1&orientation=landscape", tag: "行业深挖" },
      { id: 2, title: "独立音乐人巡演下沉小城，现场复兴正当时", category: "音乐", heat: 82.5, date: "09-02", excerpt: "越来越多的乐队把舞台搬到二三线城市，台下挤满了第一次看演出的新乐迷。", img: "https://readdy.ai/api/search-image?query=indie%20band%20live%20stage%20silhouette%20with%20guitar%20and%20warm%20lights%2C%20coral%20and%20amber%20tones%2C%20editorial%20concert%20photography%20style&width=900&height=600&seq=filter-m2&orientation=landscape", tag: "现场观察" },
      { id: 3, title: "老牌专辑重制发行，黑胶回潮到底图什么", category: "音乐", heat: 76.8, date: "08-31", excerpt: "数字时代，为什么越来越多人愿意为一张实体唱片买单。", img: "https://readdy.ai/api/search-image?query=vinyl%20records%20and%20record%20player%20collage%20on%20warm%20background%2C%20retro%20fresh%20green%20coral%20tones%2C%20music%20culture%20editorial%20still%20life&width=900&height=600&seq=filter-m3&orientation=landscape", tag: "文化回潮" },
    ],
  },
  {
    name: "生活",
    items: [
      { id: 1, title: "机场奔跑照刷屏，镜头背后的边界在哪", category: "生活", heat: 91.8, date: "09-07", excerpt: "从一张好笑的路透照聊起，谈谈公众人物与拍摄者之间需要被正视的边界。", img: "https://readdy.ai/api/search-image?query=airport%20runway%20sunset%20silhouette%20collage%2C%20warm%20coral%20golden%20tones%2C%20thoughtful%20editorial%20news%20photography%20style&width=900&height=600&seq=filter-l1&orientation=landscape", tag: "热点观察" },
      { id: 2, title: "明星街拍同款一夜售罄，穿搭经济怎么算", category: "生活", heat: 84.9, date: "09-04", excerpt: "一件卫衣引发的购买潮背后，是审美种草与消费趋势的合谋。", img: "https://readdy.ai/api/search-image?query=street%20style%20fashion%20clothing%20rack%20collage%2C%20cream%20coral%20palette%2C%20trendy%20lifestyle%20editorial%20magazine%20style&width=900&height=600&seq=filter-l2&orientation=landscape", tag: "时尚观察" },
      { id: 3, title: "宠物综艺走红背后，云吸猫为何停不下来", category: "生活", heat: 79.6, date: "08-29", excerpt: "从屏幕里的毛孩子聊到线下养宠热，情绪价值正在重塑内容消费。", img: "https://readdy.ai/api/search-image?query=cute%20cat%20and%20plant%20collage%20on%20soft%20cream%20background%2C%20fresh%20green%20coral%20accents%2C%20heartwarming%20editorial%20style&width=900&height=600&seq=filter-l3&orientation=landscape", tag: "内容观察" },
    ],
  },
  {
    name: "演出",
    items: [
      { id: 1, title: "《长夏未央》加场官宣，观演热回归城市", category: "演出", heat: 87.2, date: "09-06", excerpt: "剧院门口排起的长队，是一轮大众文化消费回暖的注脚。", img: "https://readdy.ai/api/search-image?query=theater%20stage%20red%20curtain%20spotlight%20collage%2C%20elegant%20gold%20coral%20tones%2C%20performing%20arts%20editorial%20style&width=900&height=600&seq=filter-p1&orientation=landscape", tag: "文化观察" },
      { id: 2, title: "爆款音乐剧巡演排期公布，一座城的热度密码", category: "演出", heat: 81.4, date: "09-01", excerpt: "同剧不同城，为什么有的城市一票难求、有的却需要靠口碑慢慢热起来。", img: "https://readdy.ai/api/search-image?query=musical%20stage%20props%20and%20tickets%20collage%2C%20warm%20golden%20coral%20tones%2C%20broadway%20style%20editorial%20photography&width=900&height=600&seq=filter-p2&orientation=landscape", tag: "市场分析" },
    ],
  },
  {
    name: "人物",
    items: [
      { id: 1, title: "从配角到主角：那些熬出来的演技派", category: "人物", heat: 90.6, date: "09-05", excerpt: "一位演员十年龙套路被翻出，网友感慨“作品才是最好的简历”。", img: "https://readdy.ai/api/search-image?query=spotlight%20on%20actor%20silhouette%20on%20stage%20collage%2C%20cinematic%20coral%20teal%20tones%2C%20portrait%20editorial%20style&width=900&height=600&seq=filter-r1&orientation=landscape", tag: "成长故事" },
      { id: 2, title: "导演的低谷与回归：一个创作者的十年", category: "人物", heat: 83.7, date: "09-02", excerpt: "采访手记里，导演复盘了从爆红到沉淀再到重新出发的心路。", img: "https://readdy.ai/api/search-image?query=director%20chair%20and%20film%20camera%20silhouette%20collage%2C%20warm%20coral%20amber%20tones%2C%20creator%20profile%20editorial%20style&width=900&height=600&seq=filter-r2&orientation=landscape", tag: "人物专访" },
    ],
  },
];

export const freshNews: FreshItem[] = [
  { id: 1, time: "19:20", category: "影视", title: "《回声之外》主创空降直播，回应大结局争议", brief: "导演连线首谈开放式结尾，称“下一季已在路上”。" },
  { id: 2, time: "17:05", category: "综艺", title: "《城市漫游计划》加更旅行特辑，解锁隐藏任务", brief: "本周六晚播出，六位成员将在古镇完成一次限时挑战。" },
  { id: 3, time: "15:40", category: "音乐", title: "某乐队新专辑发布即冲上实时榜前三", brief: "全专十二首歌被乐迷逐曲标记，复古合成器风大受好评。" },
  { id: 4, time: "13:12", category: "演出", title: "《长夏未央》宣布增设午间场，回应学生党呼声", brief: "主办方称首轮售罄超预期，将视上座情况决定是否继续加场。" },
  { id: 5, time: "10:26", category: "人物", title: "资深配音演员宣布退休，经典角色声线成绝响", brief: "从业三十年，曾为多部现象级作品角色配音，网友集体道谢。" },
  { id: 6, time: "08:45", category: "影视", title: "童年动画电影版放出首支片段，老配音阵容回归", brief: "熟悉的声音一响，“爷青回”直接刷屏评论区。" },
];

export const deepColumns: ColumnItem[] = [
  {
    id: 1,
    title: "一场演唱会背后的票价生态，我们算了一笔账",
    deck: "秒空、加场、转售与求票帖轮番上演。我们把票价从发行到二手市场的完整链条拆开来看，才发现真正的问题远不止“手速不够”那么简单。",
    img: "https://readdy.ai/api/search-image?query=data%20charts%20ticket%20stubs%20and%20smartphone%20collage%20on%20warm%20coral%20background%2C%20economic%20analysis%20editorial%20style%2C%20fresh%20green%20accents&width=1200&height=750&seq=column-ticket&orientation=landscape",
    author: "瓜叔说理",
    length: "阅读约 8 分钟",
    tag: "行业深挖",
  },
  {
    id: 2,
    title: "路透文化观察：镜头之后，请把边界还给人",
    deck: "从“机场奔跑照”的大范围讨论出发，我们试着回答一个问题：在记录与打扰之间，那条让所有人舒服的线到底该画在哪里。",
    img: "https://readdy.ai/api/search-image?query=photo%20camera%20lens%20and%20newspaper%20collage%2C%20coral%20and%20deep%20green%20tones%2C%20privacy%20debate%20editorial%20style&width=1200&height=750&seq=column-airport&orientation=landscape",
    author: "阿澈观察",
    length: "阅读约 6 分钟",
    tag: "热点观察",
  },
  {
    id: 3,
    title: "口碑与流量能否兼得？暑期档逆袭复盘",
    deck: "没有大爆款的一届暑期档，反而让一批口碑扎实的中腰部作品跑了出来。我们从排片、口碑发酵与观众选择三端复盘这波逆袭。",
    img: "https://readdy.ai/api/search-image?query=cinema%20crowd%20popcorn%20and%20clapperboard%20collage%2C%20golden%20coral%20tones%2C%20box%20office%20analysis%20editorial%20style&width=1200&height=750&seq=column-summer&orientation=landscape",
    author: "瓜小满",
    length: "阅读约 7 分钟",
    tag: "市场复盘",
  },
];

export const faqItems: FaqItem[] = [
  { q: "每日瓜料多久更新一次？", a: "首页的今日热榜与新鲜速递每小时滚动更新一次，本周热门瓜栏目则每周五集中重排一次，把当周最值得吃的瓜按热度归档到一页，方便你集中补课。" },
  { q: "栏目里的“热度指数”是怎么来的？", a: "热度指数综合了多个社交平台的讨论量、话题阅读量与用户互动数据加权得出，仅作为内容热度参考，不代表任何官方排名或事实结论。" },
  { q: "我看到的瓜料是否都经过核实？", a: "我们坚持“先核实、再呈现”的原则，涉及事实判断的内容均标注来源与时间线。对于尚在发酵、信息不完整的事件，会以“进行中”明确标注，避免误导。" },
  { q: "如何把有趣的瓜分享给朋友？", a: "每张瓜卡都提供分享按钮，可一键复制卡片链接或截图分享。也欢迎把你看中的瓜转发到你的群聊，一起排队吃瓜。" },
  { q: "我想投稿或提供线索，该怎么做？", a: "你可以通过页面底部的“吃瓜投稿”渠道提交线索。投稿前请尽量附上可核验的公开信息与时间点，我们会逐一评估并优先跟进高质量线索。" },
  { q: "每日瓜料需要付费才能看吗？", a: "基础的热门瓜汇总与每日速递全部免费开放。订阅“瓜料日报”仅用于把每日精选直接推送到你的邮箱，让你不错过任何值得吃的瓜。" },
];

export const stats = [
  { value: "26万+", label: "每周订阅读者" },
  { value: "480+", label: "已归档热门瓜" },
  { value: "31", label: "签约特约作者" },
  { value: "365天", label: "全年不间断更新" },
];

export const categoryTabs = ["影视", "综艺", "音乐", "生活", "演出", "人物"];